var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "-0.5 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 6.41667V2.75M14.6667 6.41667V2.75M6.41667 10.0833H15.5833M4.58333 19.25H17.4167C18.4292 19.25 19.25 18.4292 19.25 17.4167V6.41667C19.25 5.40414 18.4292 4.58333 17.4167 4.58333H4.58333C3.57081 4.58333 2.75 5.40414 2.75 6.41667V17.4167C2.75 18.4292 3.57081 19.25 4.58333 19.25Z",
    stroke: "#8C3B5E",
    strokeWidth: 1.63333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDash);
export default __webpack_public_path__ + "static/media/calendar-dash.502a13583f2fdcf9e3aff48cc80a6744.svg";
export { ForwardRef as ReactComponent };